import React, { useEffect, useState } from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import {useNavigate, useSearchParams} from 'react-router-dom';
import {useSelector} from "react-redux";
import axios from "axios";

export const OpayoSuccess = () => {
    const navigate = useNavigate();
    const [vendorTxCode, setVendorTxCode] = useState(null);
    const [searchParams] = useSearchParams();
    const apiURL = useSelector(state => state.mopriSettings.mopriAPIURL);

    useEffect(() => {
        const code = searchParams.get('vendorTxCode');
        if (code) {
            setVendorTxCode(code);
            console.log("Vendor Transaction Code:", code);
            approveOpayoTransaction(code)
        }
    }, [searchParams]);

    const approveOpayoTransaction = async (tid) => {
        const response = await axios.post(`${apiURL}/api/gateway/approve-opayo-payment`, {
            tid: tid,
        })
    }

    const goBack = () => {
        navigate('/');
    };

    return (
        <div className="grid justify-content-center align-items-center bg-green-100">
            <div className="col-12 md:col-6 lg:col-6">
                <Card
                    className="shadow-2 surface-card"
                    title={
                        <div className="flex align-items-center" style={{color: 'green'}}>
                            <FontAwesomeIcon icon={faCheckCircle} className="mr-2 text-green-500 text-2xl" />
                            <span className="text-xl font-semibold">Payment Successful</span>
                        </div>
                    }
                >
                    <div className="mb-4">
                        <img
                            src="/img/opayo.png"
                            alt={"Opayo"}
                            style={{
                                height: '60px',
                                width: 'auto',
                            }}
                        />
                        <p className="mt-2 text-lg text-gray-700">
                            Your payment was successful!
                        </p>
                        <p className="mt-2 text-lg text-gray-700">
                            Your account balance has been updated and should reflect shortly.
                        </p>
                    </div>
                    <div className="mb-4 text-gray-600">
                        <p>Thank you for your top-up.</p>
                    </div>
                    <div className="flex justify-content-end">
                        <Button label="Go to Dashboard" icon="pi pi-user" className="p-button-success" onClick={goBack} />
                    </div>
                </Card>
            </div>
        </div>
    );
};